var _defs, _line, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fc7cc657-ca91-49ac-bf0a-413106bffe0a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.05 10.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e2fb1746-0973-4394-a9b7-983f4cd4ae2e{fill:none;stroke:#fff;stroke-miterlimit:10;}.ba1d9e9a-6a38-4d20-ba42-d98a680a8b3a{fill:#fff;fill-rule:evenodd;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e2fb1746-0973-4394-a9b7-983f4cd4ae2e",
    x1: 9.05,
    y1: 5.11,
    x2: 24.05,
    y2: 5.11
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "ba1d9e9a-6a38-4d20-ba42-d98a680a8b3a",
    points: "0 5.31 9.19 0 9.19 10.61 0 5.31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.7d605f8b514a034387a3b003f3ccc8f9.svg";
export { ForwardRef as ReactComponent };